<template>
  <div class="screening">
    <!-- 分类列表 -->
    <div class="typelist">
      <div v-loading="fullscreenLoading">
        <!-- 全部结果 -->
        <div class="typela seltagall" v-if="taglist.length > 0">
          <div class="htitle">
            <h3>全部结果</h3>
          </div>
          <div class="tagsel typetxtl">
            <el-tag
              v-for="(item, key) in taglist"
              :key="key"
              type="warning"
              closable
              class="eltags"
              @close="handleClose(item, key)"
            >
              {{ item.titleA }}-{{ item.titleB }}
            </el-tag>
          </div>
        </div>
        <!-- 专业大类 -->
        <div
          class="typela"
          :class="mineShowkey == key ? 'selkeyok' : ''"
          v-for="(item, key) in typelistall"
          :key="key"
        >
          <div class="htitle" :class="mineShowkey == key ? 'selkeyokbg' : ''">
            <h3>{{ item.title }}：</h3>
          </div>
          <div class="typetxtlkey" v-if="mineShowkey == key">
            <div class="search_sctxts">
              <div class="inp_txtops">
                <el-input
                  placeholder="请输入关键词"
                  v-model="inpseach"
                  class="input-with-select"
                  @input="inptype(item, key)"
                >
                </el-input>
              </div>
              <span @click="delbtnof(item)" class="close_cirs"
                ><i class="el-icon-circle-close"></i
              ></span>
            </div>
            <el-checkbox-group
              v-model="checkedCities"
              @change="handleCheckedCitiesChange"
            >
              <el-checkbox
                v-for="(itemb, keyb) in item.children"
                :label="itemb"
                :key="keyb"
                class="check_item"
              >
                <span>{{ itemb.title }}</span>
              </el-checkbox>
            </el-checkbox-group>
            <div class="selbtnof" v-if="mineShowkey == key">
              <el-button size="mini" @click="yesbtnof(item)" class="determine"
                >确定</el-button
              >
              <el-button size="mini" @click="delbtnof(item)">取消</el-button>
            </div>
          </div>
          <div class="typetxtl" v-else :class="item.flig == true ? '' : 'typetwo'">
            <div style="margin: 15px 10px" v-if="item.flig == true && keyselradio == key">
              <el-input
                placeholder="请输入关键词"
                v-model="inpseach"
                class="input-with-select"
                @input="inptype(item, key)"
              >
              </el-input>
            </div>
            <span
              v-for="(itemb, keyb) in item.children"
              :key="keyb"
              class="spanlist"
              @click="sptxtsel(itemb, item)"
              >{{ itemb.title }}</span
            >
          </div>

          <span
            v-if="item.children.length > 6 && mineShowkey !== key"
            class="setupas"
            @click="setopen(item, key)"
          >
            <!-- {{ item.flig == false ? "展开" : "收起" }} -->
            <i
              :class="[
                'insetupas',
                'el-icon-caret-bottom',
                item.flig == false ? '' : 'myrotate',
              ]"
            ></i>
          </span>
          <span
            v-if="mineShowkey !== key"
            class="selicons"
            @click="seltagcheckbox(item, key)"
          >
            <i class="el-icon-plus"></i>
          </span>
        </div>
        <!-- 媒体类型 -->
        <div class="typela">
          <div class="htitle">
            <h3>媒体类型：</h3>
          </div>
          <div class="typetxtl">
            <span
              v-for="(item, key) in mediaTypeOptions"
              :key="key"
              class="spanlist"
              :class="mediacss == true && mediaType == item.index ? 'selcssa' : ''"
              @click="meditsel(item, key)"
              >{{ item.name }}</span
            >
          </div>
        </div>
        <!-- 筛选条件 -->
        <div class="condition" v-show="prdshow">
          <!-- <span class="paixulist">排序方式</span> -->
          <div class="radiolist">
            <el-radio-group v-model="radio" @change="radiochange">
              <el-radio :label="0">默认排序</el-radio>
              <el-radio :label="1">点赞量</el-radio>
              <el-radio :label="2">点击量</el-radio>
              <!-- <el-radio :label="3">收藏量</el-radio> -->
            </el-radio-group>
          </div>
          <div class="search_op">
            <el-input
              placeholder="请输入素材名称搜索"
              v-model="searval"
              class="input-with-select"
              @change="searchBtns"
              @clear="searchBtns"
              clearable
            >
              <el-button
                slot="append"
                @click="searchBtns"
                icon="el-icon-search"
              ></el-button>
            </el-input>
          </div>
          <p class="suctotal">
            找到 <span>{{ total }}个素材</span>
          </p>
          <div class="suctotal">
            <el-button v-if="isShowBtn" type="warning" size="mini" @click="handelDownLoad(1)">批量下载</el-button>
            <el-button v-if="!isShowBtn" plain type="warning" size="mini" @click="handelDownLoad(2)">取消下载</el-button>
            <el-button v-if="!isShowBtn" size="mini" type="warning" @click="handelDownLoad(3)">确定下载</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 删除指定的数组元素---扩展方法
import {getToken} from "@/utils/auth";

Array.prototype.arrindex = function (val) {
  for (let index = 0; index < this.length; index++) {
    if (this[index] == val) {
      return index;
    }
  }
  return -1;
};
Array.prototype.remove = function (val) {
  var index = this.arrindex(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};
import { webList, getTypes } from "@/api/library";
export default {
  name: "screening",
  data() {
    return {
      tokens: getToken(),
      isShowBtn:true,
      typelista: [{ title: "全部", selstatus: true }], //全部类
      // 其他类型
      typeshowds: [
        { title: "全部", sample: "" },
        { title: "样片", sample: true },
      ],
      showsp: true,
      opentxt: "展开",
      selcss: 0,
      mediacss: true, //媒体类型css
      samplecss: true, //其他类型
      sampleType: "",
      size: 12,
      page: 1,
      baseurl: process.env.VUE_APP_BASE_API,
      radio: 0, //排序方式
      typessel: {}, //筛选参数
      sample: false, //样片 0是 1否
      keywords: "", //输入框val
      listIda: [], //专业大类下的子类集合
      typelistall: [], //筛选类型集合
      typeobj: {},
      openindex: 0, //点击展开折叠当前的id
      mediaTypeOptions: [], //媒体类型
      mediaType: "", //媒体类型传参
      sortName: "", //排序
      itemIdlist: [], //筛选时的关联ID
      fullscreenLoading: false, //页面的loading
      settimeall: null, //延迟器
      seldatalls: [], //多选---大类下的ID
      taglist: [],
      mineShowkey: null,
      checkedCities: [], //check
      selectBigId: [], //多选---大类ID
      prdshow: true,
      inpseach: "", //搜索专业类
      typelistalltwo: [], //筛选类型集合
      keysearch: null, //搜索时记录key
      keyselradio: null, //点击展开记录key
      searval: "", //搜索内容
    };
  },
  props: {
    total: {
      type: Number,
      default: 0,
    },
    checkList:{
      type:Array,
      default: []
    }
  },
  watch:{


  },
  mounted() {
    this.classlist(); //大类查询
    this.getMediaTypes(); //媒体类型
  },
  methods: {
    classlist() {
      this.fullscreenLoading = true;
      let selectBigId = [...new Set([...this.selectBigId])];
      // 类型列表
      webList({ selectId: this.seldatalls, selectBigId: selectBigId })
        .then((res) => {
          if (res.code == 200) {
            this.typelistall = res.rows;
            this.typelistalltwo = JSON.parse(JSON.stringify(res.rows));
            this.typelistall.forEach((val, key) => {
              let objkey = "big" + val.id;
              this.typessel[objkey] = [];
              this.$set(val, "flig", false);
              val.children = [...val.children];
            });
            //从专题网点击比如 大赛模板 跳转过来
            let datasa = this.$route.query;
            if (datasa.xiaolei) {
              let xlobj;
              let dlobj = this.typelistall.filter((el) => {
                if (Number(datasa.dalei) === el.id) {
                  xlobj = el.children.filter((val) => {
                    return Number(datasa.xiaolei) === val.id;
                  });
                  return el;
                }
              });
              if (dlobj.length > 0 && xlobj.length > 0) {
                this.sptxtsel(...xlobj, ...dlobj);
              }

              this.$router.push({ path: "/" });
            }
          } else {
          }
          this.fullscreenLoading = false;
        })
        .catch((err) => {
          this.fullscreenLoading = false;
        });
    },
    //媒体类型
    getMediaTypes() {
      // this.$http.get("/business/big/getTypes")
      getTypes().then((res) => {
        if (res.code == 200) {
          let selmedall = [{ name: "全部", index: "" }];
          this.mediaTypeOptions = selmedall.concat(res.data);
        }
      });
    },
    meditsel(item) {
      this.mediacss = true;
      this.mediaType = item.index;
      this.$emit("pagedata", { page: 1, mediaType: this.mediaType });
    },
    // 其他类型---样片
    samplesel(item, key) {
      this.samplecss = true;
      this.sampleType = item.sample;
      this.$emit("pagedata", { page: 1, sampleType: this.sampleType });
    },
    // 排序方式
    radiochange(val) {
      this.radio = val;
      switch (this.radio) {
        case 0:
          this.sortName = "";
          break;
        case 1:
          this.sortName = "pros";
          break;
        case 2:
          this.sortName = "clicks";
          break;
        case 3:
          this.sortName = "collectedCount";
          break;
        case 4:
          this.sortName = "downloads";
          break;
        default:
          break;
      }
      this.$emit("pagedata", { page: 1, sortName: this.sortName });
    },
    // 展开折叠
    setopen(item, key) {
      item.flig = !item.flig;
      if (item.flig == true) {
        this.keyselradio = key;
      }

      this.inpseach = "";
      if (this.keysearch !== null) {
        this.seartype(this.keysearch);
      }
    },
    //专业类筛选
    sptxtsel(item, itmeclass) {
      if (this.seldatalls.indexOf(item.id) > -1) {
        this.$message({
          message: "请不要重复添加",
          type: "warning",
        });
        return;
      }
      if (this.selectBigId.indexOf(itmeclass.id) > -1) {
        this.$message({
          message: "请不要重复添加",
          type: "warning",
        });
        return;
      }
      let typekey = itmeclass.id;
      // 传输数据
      this.typessel["big" + typekey].push(item.id);
      // 标签
      this.taglist.push({
        idA: itmeclass.id,
        idB: item.id,
        titleA: itmeclass.title,
        titleB: item.title,
      });
      this.seldatalls.push(item.id);
      this.selectBigId.push(itmeclass.id);
      this.classlist(); //大类查询
      this.$emit("pagedata", { page: 1, typessel: this.typessel });
    },
    // 删除tag标签
    handleClose(tag, key) {
      //tag参数
      this.taglist.splice(this.taglist.indexOf(tag), 1);
      //webList分类参数
      this.seldatalls.splice(this.seldatalls.indexOf(tag.idB), 1);
      this.selectBigId.splice(this.selectBigId.indexOf(tag.idA), 1);
      //es搜索参数
      let arrIndex = this.typessel["big" + tag.idA].indexOf(tag.idB);
      this.typessel["big" + tag.idA].splice(arrIndex, 1);
      this.classlist(); //大类查询
      this.$emit("pagedata", { page: 1, typessel: this.typessel });
    },
    // 多选按钮
    seltagcheckbox(item, key) {
      this.mineShowkey = key;
      this.checkedCities = [];
      this.inpseach = "";
      if (this.keysearch !== null) {
        this.seartype(this.keysearch);
      }
    },
    // 多选--确定
    yesbtnof(item) {
      for (let index = 0; index < this.checkedCities.length; index++) {
        //tag标签
        this.taglist.push({
          idA: this.typelistall[this.mineShowkey].id,
          idB: this.checkedCities[index].id,
          titleA: this.typelistall[this.mineShowkey].title,
          titleB: this.checkedCities[index].title,
        });

        //  大类查询参数
        this.seldatalls.push(this.checkedCities[index].id);

        this.selectBigId.push(this.typelistall[this.mineShowkey].id);

        this.typessel["big" + this.typelistall[this.mineShowkey].id].push(
          this.checkedCities[index].id
        );
      }
      //  ES查询参数
      this.classlist(); //大类查询
      this.$emit("pagedata", { page: 1, typessel: this.typessel });

      this.mineShowkey = null;
      this.checkedCities = [];
      item.flig = false;
      this.inpseach = "";
    },
    // 取消
    delbtnof(item) {
      this.mineShowkey = null;
      this.checkedCities = [];
      item.flig = false;
      this.inpseach = "";
      if (this.keysearch !== null) {
        this.seartype(this.keysearch);
      }
    },
    //多选的check
    handleCheckedCitiesChange(value) {
      // console.log(this.checkedCities,'多选checkedCities')
    },
    //搜索专业类
    searchtype(item, key) {
      this.typelistall[key].children = this.typelistalltwo[key].children;
      if (this.inpseach == "") {
        return;
      }

      let chiltype = [];
      item.children.filter((el) => {
        if (el.title.indexOf(this.inpseach) !== -1) {
          chiltype.push(el);
        }
      });
      let tylist = [...new Set([...this.checkedCities]), ...chiltype];
      this.typelistall[key].children = [...new Set([...tylist])];
    },
    // 重置
    seartype(key) {
      this.typelistall[key].children = this.typelistalltwo[key].children;
      this.checkedCities = [];
    },
    // 搜索输入框
    inptype(item, key) {
      this.searchtype(item, key);
      this.keysearch = key;
    },
    //下载
    handelDownLoad(type){
      if (this.tokens) {
        if(type==1){
          this.isShowBtn=false
        }else if(type==2){
          this.isShowBtn=true
        }else if(type==3){
          if(this.$props.checkList.length!=0){
            this.isShowBtn=true
          }else{
            this.isShowBtn=false
          }
        }
        this.$emit("downLoad",{typeValue:type,isShowBtn:this.isShowBtn});
      } else {
        this.$message({
          message: "请先登陆",
          type: "error",
          offset: 200,
        });
      }

    },
    //搜索
    searchBtns() {
      this.$emit("pagedata", { page: 1, keywords: this.searval });
    },
  },
};
</script>
<style lang="scss" scoped>
.screening {
  margin-top: 40px;
}
.typelist {
  width: 100%;
}
.typela {
  width: 100%;
  margin: 0 auto;
  display: flex;
  position: relative;
  border-bottom: 1px solid #f5f5f5;
}
.typela:nth-child(1) {
  border-top: 1px solid #f5f5f5;
}
.htitle {
  width: 100px;
  padding: 0 5px;
  line-height: 38px;
  color: #666666;
  overflow: hidden;
  h3 {
    font-size: 16px;
  }
}
.typetxtl {
  flex: 1;
  margin-top: 5px;
  overflow: hidden;
  padding-right: 30px;
}
// 多选
.typetxtlkey {
  flex: 1;
  padding: 5px 15px;
}
.search_sctxts {
  overflow: hidden;
  position: relative;
}
.inp_txtops {
  margin-top: 10px;
  width: 80%;
}
.close_cirs {
  position: absolute;
  right: 0;
  top: 0px;
  font-size: 22px;
  color: #B18227;
  cursor: pointer;
}
.check_item {
  margin-top: 10px;
}
/* 折叠状态 */
.typetwo {
  height: 29px;
  overflow: hidden;
}
.typetxtl span {
  font-size: 15px;
  margin-bottom: 5px;
  border: 1px solid #fff;
}
.spanlist {
  display: inline-block;
  line-height: 25px;
  vertical-align: middle;
  margin: 0 5px;
  padding: 0 15px;
  cursor: pointer;
  border-radius: 16px;
  color: #333333;
  transition: all 0.2s;
}
.spanlist:hover {
  color: #B18227;
}
.setupas {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  line-height: 19px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  margin: 8px 5px 0 0;
  transition: all 0.2s;
  color: #333333;
  i {
    margin-left: 1px;
  }
  .insetupas {
    transition: all 0.3s;
    &.myrotate {
      transform: rotate(180deg);
    }
  }
}
.setupas:hover {
  color: #B18227;
}
/* 选中后的样式 */
.selcssa {
  color: #B18227;
}
/* 筛选 */
.condition {
  height: 50px;
  background-color: #f5f5f5;
  line-height: 50px;
  padding: 0 5px;
  margin: 0 auto;
  margin-top: 10px;
  overflow: hidden;
}
.paixulist {
  font-size: 15px;
  color: #606266;
  float: left;
}

.search_op {
  float: left;
  margin-left: 40px;
  border-radius: 20px;

  /*搜索input框 */
  ::v-deep .el-input__inner {
    border-radius: 20px 0 0 20px !important;
    border: 0;
    box-shadow: 0 0 0 0px;
    height: 35px;
  }
  /*搜索button按钮 */
  ::v-deep .el-input-group .el-input-group__append {
    border-radius: 0 20px 20px 0 !important;
    border: 2px solid #ffffff;
    box-shadow: 0 0 0 0px;
  }
}
.suctotal {
  float: right;
  font-size: 14px;
  margin-right: 20px;
  span {
    color: #B18227;
  }
}
// 选中后的标签展示
.seltagall {
  .tagsel {
    padding: 0 15px;
    .eltags {
      background-color: #fff;
      color: #B18227;
      border: none;
      border-radius: 16px;
    }
    span {
      margin-left: 5px;
    }
  }
}
// 多选按钮
.selicons {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  line-height: 18px;
  margin-top: 8px;
  font-size: 16px;
  color: #333333;
  cursor: pointer;
  text-align: center;
  i {
    margin-left: 1px;
  }
  &:hover {
    color: #B18227;
  }
}
// 点击多选后的按钮
.selbtnof {
  width: 100%;
  text-align: center;
  padding: 15px 0 0 0;
  .determine {
    background-color: #B18227;
    color: #fff;
  }
}
// 点击多选后的样式
.selkeyok {
  border: 2px solid #B18227;
}
.selkeyokbg {
  background-color: #B18227;
  color: #fff;
}
</style>
<style lang="scss">
.radiolist {
  margin-left: 10px;
  float: left;
  /* 选中后的字体颜色 */
  .el-radio__input.is-checked + .el-radio__label {
    color: #B18227 !important;
  }
  /* 选中后小圆点的颜色 */
  .el-radio__input.is-checked .el-radio__inner {
    background: #B18227 !important;
    border-color: #B18227 !important;
  }
}
</style>
